import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";

import VLFModal from "@/components/Modal";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import VLFSelectNew from "@/components/Input/SelectNew";
import Button from "@mui/material/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import {LanguageSwitcher} from "@/components/LanguageSwitcher";

import {RosterAPI} from "@/api/roster";
import {StaffAPI} from "@/api/staff";

import {Collapse} from "@mui/material";
import {ExpandLess, ExpandMore} from "@mui/icons-material";

import {logout, setSelectedMenuItem, setCurrentSeason} from "@/actions";

import {headerMenuItems} from "@/utils/constants";

function SideMenu() {
	const dispatch = useDispatch();
	const location = useLocation();
	const {t} = useTranslation();

	const selectedMenuItem = useSelector((state) => state?.selectedMenuItem);

	const user = useSelector((state) => state?.user);
	const userRole = useSelector((state) => state?.user?.roleName);

	const playerId = useSelector((state) => state?.user?.playerId);

	const seasons = useSelector((state) => state?.seasons);
	const seasonId = useSelector((state) => state?.season?.id);

	const [openMobileMenu, setOpenMobileMenu] = useState(false);
	const [openHandleLogout, setOpenHandleLogout] = useState(false);
	const [openSubMenu, setOpenSubMenu] = useState(false);

	const [teams, setTeams] = useState([]);
	// const [userTeams, setUserTeams] = useState([]);

	// useEffect(() => {
	// 	const getInfo = async () => {
	// 		if (user?.staffId) {
	// 			const userInfo = await StaffAPI.getById(user?.staffId);
	// 			setUserTeams(userInfo?.categories?.map((c) => c.playersCategoryId));
	// 		}
	// 	};

	// 	getInfo();
	// }, [user]);

	const visibleHeaderMenuItems = headerMenuItems(t).filter(
		(item) => item.roles.indexOf(userRole?.toLowerCase()) !== -1,
	);

	const normalize = (s) => s.normalize("NFC").trim().toLowerCase();
	const stripSlash = (p) => p.replace(/\/+$/, "");

	const getItemClassName = (path) => {
		const target = new URL(path, window.location.origin);

		const curPath = stripSlash(location.pathname);
		const targetPath = stripSlash(target.pathname);

		const targetParams = Array.from(target.searchParams.entries());

		const pathMatch =
			targetParams.length > 0
				? curPath === targetPath
				: curPath === targetPath || curPath.startsWith(targetPath + "/");

		if (!pathMatch) return "";

		if (targetParams.length === 0) return "selected";

		const curParams = new URLSearchParams(location.search);
		const paramsMatch = targetParams.every(([k, v]) => {
			const cur = curParams.get(k);
			return cur !== null && normalize(cur) === normalize(v);
		});

		return paramsMatch ? "selected" : "";
	};

	const getUserInfo = () => {
		return (
			<div className="user-info-container">
				<div className="d-flex align-items-center">
					<div className="user-icon-container">
						<img
							className="user-icon"
							src={require("@/assets/images/user.png")}
							alt=""
						/>
					</div>
					<div className="user-container d-flex flex-column">
						<div className="user-data">{user?.userName}</div>
						<div className="user-role">{user?.roleName}</div>
					</div>
				</div>
				<LanguageSwitcher />
				<Button
					variant="outlined"
					color="primary"
					size="small"
					onClick={() => setOpenHandleLogout(true)}
				>
					<LogoutIcon />
				</Button>
			</div>
		);
	};

	const getTeams = async () => {
		try {
			const response = await RosterAPI.list({seasonId, prospect: false});
			setTeams(
				response
					.filter(
						(t) => !t.prospect,
						// &&
						// 	(!userTeams?.length ||
						// 		userTeams?.indexOf(t.playerCategory?.id) !== -1),
					)
					.sort((a, b) => a.playerCategory.sorting - b.playerCategory.sorting),
			);
		} catch (error) {
			console.log(error);
		}
	};
	useEffect(() => {
		getTeams();
	}, []);

	const getListItem = (listItem) => {
		const handleItemClick = () => {
			if (listItem.subMenu) {
				setOpenSubMenu(!openSubMenu);
			} else {
				setOpenMobileMenu(false);
			}
		};
		return (
			<>
				<ListItem
					className={
						getItemClassName(listItem.path) +
						(!listItem.imagePath ? " only-text" : "")
					}
					button
					component={listItem.subMenu ? "div" : Link}
					to={!listItem.subMenu ? listItem.path : undefined}
					onClick={handleItemClick}
				>
					<ListItemIcon>
						<img
							className={
								"item-icon" +
								(listItem.imageClassName ? " " + listItem.imageClassName : "")
							}
							src={listItem.imagePath}
							alt=""
						/>
					</ListItemIcon>
					<ListItemText primary={listItem.label} />
					{listItem.subMenu && (openSubMenu ? <ExpandLess /> : <ExpandMore />)}
				</ListItem>

				{listItem.subMenu && openSubMenu && (
					<List component="div" disablePadding>
						{listItem.subMenu.map((subItem, index) => (
							<ListItem
								key={index}
								className={getItemClassName(subItem.path)}
								button
								component={Link}
								to={subItem.path}
								onClick={() => setOpenMobileMenu(false)}
							>
								<ListItemIcon>
									<img className="item-icon" src={subItem.imagePath} alt="" />
								</ListItemIcon>
								<ListItemText primary={subItem.label} />
							</ListItem>
						))}
					</List>
				)}
			</>
		);
	};

	const [clubOpen, setClubOpen] = useState(false);
	const [teamsOpen, setTeamsOpen] = useState(false);
	const [performanceOpen, setPerformanceOpen] = useState(false);
	const [eventsOpen, setEventsOpen] = useState(false);
	const [scoutingOpen, setScoutingOpen] = useState(false);
	const [developmentOpen, setDevelopmentOpen] = useState(false);
	const [videoOpen, setVideoOpen] = useState(false);
	// const [scoutingValuationsOpen, setScoutingValuationsOpen] = useState(false);

	useEffect(() => {
		const splittedCurrentPath = location.pathname.split("/").filter((s) => s);
		if (splittedCurrentPath[0] === "manager") {
			setClubOpen(true);
		}
		if (splittedCurrentPath[1] === "teams") {
			setTeamsOpen(true);
		}
	}, [location.pathname]);

	useEffect(() => {
		const splittedCurrentPath = location.pathname.split("/").filter((s) => s);
		if (splittedCurrentPath[0] === "scouting") {
			setScoutingOpen(true);
		}
	}, [location.pathname]);

	useEffect(() => {
		const splittedCurrentPath = location.pathname.split("/").filter((s) => s);
		if (splittedCurrentPath[0] === "development") {
			setDevelopmentOpen(true);
		}
	}, [location.pathname]);

	useEffect(() => {
		const splittedCurrentPath = location.pathname.split("/").filter((s) => s);
		if (splittedCurrentPath[0] === "video") {
			setVideoOpen(true);
		}
	}, [location.pathname]);

	const handleClick = (setFunction, element) => {
		setFunction(!element);
	};

	const getList = (mobile = false) => {
		let list = <></>;

		const formattedSeasons = seasons.map((s) => ({
			value: s.id,
			label: s.name,
		}));

		const selectedSeason = formattedSeasons.find((s) => s.value === seasonId);

		// Ultime 3 stagioni visibili nel selettore globale:
		// le 3 con startDate più recente (corrente + le 2 precedenti).
		const visibleSeasons = [...seasons]
			.sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
			.slice(0, 3)
			.map((s) => ({value: s.id, label: s.name}));

		const seasonSelectStyles = {
			control: (provided, state) => ({
				...provided,
				marginTop: "0px",
				marginBottom: "0px",
				minHeight: "40px",
				border: "none",
				borderRadius: "16px",
				backgroundColor: "rgba(255, 255, 255, 0.35)",
				boxShadow: state.isFocused
					? "0 0 0 2px rgba(16, 89, 191, 0.25)"
					: "none",
				"&:hover": {
					borderColor: "transparent",
				},
			}),
			valueContainer: (provided) => ({
				...provided,
				padding: "0 16px",
			}),
			placeholder: (provided) => ({
				...provided,
				color: "rgba(5, 8, 24, 0.5)",
			}),
			singleValue: (provided) => ({
				...provided,
				color: "#0b1f44",
				fontWeight: 600,
			}),
			menu: (provided) => ({
				...provided,
				borderRadius: "14px",
				overflow: "hidden",
			}),
			option: (provided, state) => ({
				...provided,
				backgroundColor: state.isSelected
					? "rgba(16, 89, 191, 0.15)"
					: state.isFocused
						? "rgba(16, 89, 191, 0.08)"
						: "transparent",
				color: state.isSelected ? "#0b1f44" : "#0b1f44",
			}),
		};

		const seasonsSelect = (
			<div className="season-card">
				<div className="season-card__header">
					<div className="season-card__label">Stagione attiva</div>
					<div className="season-card__current">
						{selectedSeason?.label || "—"}
					</div>
					{/* <div className="season-card__hint">
						Aggiorna calendari e dashboard con un tap
					</div> */}
				</div>
				<VLFSelectNew
					classNamePrefix="season-select"
					containerStyles={{
						width: "100%",
					}}
					styles={seasonSelectStyles}
					options={visibleSeasons}
					isClearable={false}
					sortOrder="descend"
					value={selectedSeason}
					placeholder="Scegli stagione"
					onChange={(item) => {
						if (!item) return;
						dispatch(
							setCurrentSeason({
								season: seasons?.find((s) => s.id === item.value),
							}),
						);
						localStorage.setItem("seasonId", item.value);
						window.location.reload();
					}}
				/>
			</div>
		);

		const scoutingList = (
			<List component="div" disablePadding>
				{/* {getListItem({
					path: "/scouting/dashboard",
					imagePath: require("@/assets/images/manager/performance.png"),
					label: "Dashboard",
				})} */}
				{getListItem({
					path: "/scouting/internal-comparison",
					imagePath: require("@/assets/images/scout/search.png"),
					label: "Comparazione",
				})}
				{getListItem({
					path: "/scouting/reports",
					imagePath: require("@/assets/images/scout/alert.png"),
					label: t("reports"),
				})}
				{getListItem({
					path: "/scouting/tryouts",
					imagePath: require("@/assets/images/manager/evaluation.png"),
					label: t("tryouts"),
				})}
				{getListItem({
					path: "/scouting/valuations",
					imagePath: require("@/assets/images/scout/search.png"),
					label: t("valuations"),
				})}
				{getListItem({
					path: "/scouting/staffs",
					imagePath: require("@/assets/images/manager/staff.png"),
					label: t("coaches"),
				})}
				{getListItem({
					path: "/scouting/planning",
					imagePath: require("@/assets/images/coach/match.png"),
					label: t("planning"),
				})}
				{getListItem({
					path: "/scouting/players",
					imagePath: require("@/assets/images/scout/archive.png"),
					label: t("database"),
				})}
			</List>
		);

		// basarsi su user role
		switch (selectedMenuItem) {
			case "manager":
				list = (
					<List className="side-menu-list">
						<ListItem button onClick={() => handleClick(setClubOpen, clubOpen)}>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon img"
										src={require("@/assets/images/old/logo_player.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary="U.C. Sampdoria" />
							{clubOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={clubOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{getListItem({
									path: "/director/dashboard",
									imagePath: require("@/assets/images/manager/business.png"),
									label: "Dashboard",
								})}
								<ListItem
									button
									onClick={() => handleClick(setTeamsOpen, teamsOpen)}
								>
									<ListItemIcon>
										<ListItemIcon>
											<img
												className="item-icon"
												src={require("@/assets/images/manager/club.png")}
												alt=""
											/>
										</ListItemIcon>
									</ListItemIcon>
									<ListItemText primary={t("rosters")} />
									{teamsOpen ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={teamsOpen} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										{teams?.map((t, k) => {
											return (
												<div key={k}>
													{getListItem({
														path: "/manager/teams/" + t.id,
														label: t.playerCategory?.name,
													})}
												</div>
											);
										})}
									</List>
								</Collapse>
								{getListItem({
									path: "/players",
									imagePath: require("@/assets/images/manager/movement_player.png"),
									label: t("players"),
								})}
								{getListItem({
									path: "/manager/players-comparison",
									imagePath: require("@/assets/images/manager/business.png"),
									label: "Confronta Giocatori",
								})}
								{getListItem({
									path: "/goalkeepers",
									imagePath: require("@/assets/images/manager/player.png"),
									label: t("goalkeepers"),
								})}
								{getListItem({
									path: "/manager/staffs",
									imagePath: require("@/assets/images/manager/staff.png"),
									label: t("staff"),
								})}
							</List>
						</Collapse>
						<ListItem
							button
							onClick={() => handleClick(setEventsOpen, eventsOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/football.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("activities")} />
							{eventsOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={eventsOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{getListItem({
									path: "/match-calendar",
									imagePath: require("@/assets/images/manager/calendar.png"),
									label: t("calendar"),
								})}
								{getListItem({
									path: "/matches",
									imagePath: require("@/assets/images/coach/match.png"),
									label: t("matches"),
								})}
								{getListItem({
									path: "/trainings",
									imagePath: require("@/assets/images/coach/training.png"),
									label: t("trainings"),
								})}
								{getListItem({
									path: "/exercises",
									imagePath: require("@/assets/images/manager/exercise.png"),
									label: t("exercises"),
								})}
							</List>
						</Collapse>
						<ListItem
							button
							onClick={() => handleClick(setPerformanceOpen, performanceOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/business.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("performance")} />
							{performanceOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={performanceOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{getListItem({
									path: "/measurations/tqr",
									imagePath: require("@/assets/images/coach/tqr.png"),
									label: t("recoveries"),
								})}
								{getListItem({
									path: "/measurations/rpe",
									imagePath: require("@/assets/images/coach/rpe.png"),
									label: t("rpe"),
								})}
								{getListItem({
									path: "/measurations/vas",
									imagePath: require("@/assets/images/coach/muscle-pain.png"),
									label: t("vas"),
								})}
								{getListItem({
									path: "/athletic-tests",
									imagePath: require("@/assets/images/coach/test.png"),
									label: t("athletic_tests"),
								})}
								{getListItem({
									path: "/match-reports",
									imagePath: require("@/assets/images/manager/evaluation.png"),
									label: t("match_report"),
								})}
							</List>
						</Collapse>
						<ListItem
							button
							onClick={() => handleClick(setScoutingOpen, scoutingOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/scout/search.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("scouting")} />
							{scoutingOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse
							in={scoutingOpen}
							timeout="auto"
							unmountOnExit
							className="collapsed"
						>
							{scoutingList}
						</Collapse>
						<ListItem
							button
							onClick={() => handleClick(setDevelopmentOpen, developmentOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/target.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("development")} />
							{developmentOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse
							in={developmentOpen}
							timeout="auto"
							unmountOnExit
							className="collapsed"
						>
							<List component="div" disablePadding>
								{getListItem({
									path: "/development/rosters",
									imagePath: require("@/assets/images/manager/player.png"),
									label: t("roster_en"),
								})}
								{getListItem({
									path: "/development/targets",
									imagePath: require("@/assets/images/manager/target2.png"),
									label: t("target"),
								})}
							</List>
						</Collapse>
						{getListItem({
							path: "/medical/records",
							imagePath: require("@/assets/images/medical/record.png"),
							label: t("medical_area"),
						})}
						<ListItem
							button
							onClick={() => handleClick(setVideoOpen, videoOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/video.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("video")} />
							{videoOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse
							in={videoOpen}
							timeout="auto"
							unmountOnExit
							className="collapsed"
						>
							<List component="div" disablePadding>
								{getListItem({
									path: "/video?type=Clip allenamento",
									label: "Clip allenamento",
								})}
								{getListItem({
									path: "/video?type=Clip gara",
									label: "Clip gara",
								})}
								{getListItem({
									path: "/video?type=Video tecnici",
									label: "Video tecnici",
								})}
							</List>
						</Collapse>
					</List>
				);
				break;
			case "coach":
				list = (
					<List className="side-menu-list">
						<ListItem button onClick={() => handleClick(setClubOpen, clubOpen)}>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon img"
										src={require("@/assets/images/old/logo_player.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary="U.C. Sampdoria" />
							{clubOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={clubOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								<ListItem
									button
									onClick={() => handleClick(setTeamsOpen, teamsOpen)}
								>
									<ListItemIcon>
										<ListItemIcon>
											<img
												className="item-icon"
												src={require("@/assets/images/manager/club.png")}
												alt=""
											/>
										</ListItemIcon>
									</ListItemIcon>
									<ListItemText primary={t("rosters")} />
									{teamsOpen ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={teamsOpen} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										{teams?.map((t, k) => {
											return (
												<div key={k}>
													{getListItem({
														path: "/manager/teams/" + t.id,
														label: t.playerCategory?.name,
													})}
												</div>
											);
										})}
									</List>
								</Collapse>
								{getListItem({
									path: "/players",
									imagePath: require("@/assets/images/manager/movement_player.png"),
									label: t("players"),
								})}
								{user?.userName !== "TimossiL" &&
									getListItem({
										path: "/goalkeepers",
										imagePath: require("@/assets/images/manager/player.png"),
										label: t("goalkeepers"),
									})}
								{user?.userName !== "TimossiL" &&
									getListItem({
										path: "/manager/staffs",
										imagePath: require("@/assets/images/manager/staff.png"),
										label: t("staff"),
									})}
							</List>
						</Collapse>
						<ListItem
							button
							onClick={() => handleClick(setEventsOpen, eventsOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/football.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("activities")} />
							{eventsOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={eventsOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{getListItem({
									path: "/match-calendar",
									imagePath: require("@/assets/images/manager/calendar.png"),
									label: t("calendar"),
								})}
								{getListItem({
									path: "/matches",
									imagePath: require("@/assets/images/coach/match.png"),
									label: t("matches"),
								})}
								{getListItem({
									path: "/trainings",
									imagePath: require("@/assets/images/coach/training.png"),
									label: t("trainings"),
								})}
								{getListItem({
									path: "/exercises",
									imagePath: require("@/assets/images/manager/exercise.png"),
									label: t("exercises"),
								})}
							</List>
						</Collapse>
						<ListItem
							button
							onClick={() => handleClick(setPerformanceOpen, performanceOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/business.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("performance")} />
							{performanceOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={performanceOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{getListItem({
									path: "/measurations/tqr",
									imagePath: require("@/assets/images/coach/tqr.png"),
									label: t("recoveries"),
								})}
								{getListItem({
									path: "/measurations/rpe",
									imagePath: require("@/assets/images/coach/rpe.png"),
									label: t("rpe"),
								})}
								{getListItem({
									path: "/measurations/vas",
									imagePath: require("@/assets/images/coach/muscle-pain.png"),
									label: t("vas"),
								})}
								{getListItem({
									path: "/athletic-tests",
									imagePath: require("@/assets/images/coach/test.png"),
									label: t("athletic_tests"),
								})}
								{getListItem({
									path: "/match-reports",
									imagePath: require("@/assets/images/manager/evaluation.png"),
									label: t("match_report"),
								})}
							</List>
						</Collapse>
						{user?.userName === "CeccariniL" ? (
							<>
								<ListItem
									button
									onClick={() => handleClick(setScoutingOpen, scoutingOpen)}
								>
									<ListItemIcon>
										<ListItemIcon>
											<img
												className="item-icon"
												src={require("@/assets/images/scout/search.png")}
												alt=""
											/>
										</ListItemIcon>
									</ListItemIcon>
									<ListItemText primary={t("scouting")} />
									{scoutingOpen ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse
									in={scoutingOpen}
									timeout="auto"
									unmountOnExit
									className="collapsed"
								>
									<List component="div" disablePadding>
										{getListItem({
											path: "/scouting/reports",
											imagePath: require("@/assets/images/scout/alert.png"),
											label: t("reports"),
										})}
										{getListItem({
											path: "/scouting/tryouts",
											imagePath: require("@/assets/images/manager/evaluation.png"),
											label: t("tryouts"),
										})}
										{getListItem({
											path: "/scouting/valuations",
											imagePath: require("@/assets/images/scout/search.png"),
											label: t("valuations"),
										})}
										{getListItem({
											path: "/scouting/staffs",
											imagePath: require("@/assets/images/manager/staff.png"),
											label: t("coaches"),
										})}
										{getListItem({
											path: "/scouting/planning",
											imagePath: require("@/assets/images/coach/match.png"),
											label: t("planning"),
										})}
										{getListItem({
											path: "/scouting/players",
											imagePath: require("@/assets/images/scout/archive.png"),
											label: t("database"),
										})}
									</List>
								</Collapse>
							</>
						) : null}
					</List>
				);
				break;
			case "player":
				list = (
					<List className="side-menu-list">
						{getListItem({
							path: "/profile/" + playerId,
							imagePath: require("@/assets/images/manager/player.png"),
							label: t("profile"),
						})}
						<ListItem
							button
							onClick={() => handleClick(setPerformanceOpen, performanceOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/performance.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("performance")} />
							{performanceOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={performanceOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{getListItem({
									path: "/measurations/tqr",
									imagePath: require("@/assets/images/coach/tqr.png"),
									label: t("recoveries"),
								})}
								{getListItem({
									path: "/measurations/rpe",
									imagePath: require("@/assets/images/coach/rpe.png"),
									label: t("rpe"),
								})}
								{getListItem({
									path: "/measurations/vas",
									imagePath: require("@/assets/images/coach/muscle-pain.png"),
									label: t("vas"),
								})}
							</List>
						</Collapse>
						{getListItem({
							path: "/trainings",
							imagePath: require("@/assets/images/coach/training.png"),
							label: t("trainings"),
						})}
						{getListItem({
							path: "/matches",
							imagePath: require("@/assets/images/coach/match.png"),
							label: t("matches"),
						})}
						<ListItem
							button
							onClick={() => handleClick(setVideoOpen, videoOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/video.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("video")} />
							{videoOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse
							in={videoOpen}
							timeout="auto"
							unmountOnExit
							className="collapsed"
						>
							<List component="div" disablePadding>
								{getListItem({
									path: "/video?type=Clip allenamento",
									label: "Clip allenamento",
								})}
								{getListItem({
									path: "/video?type=Clip gara",
									label: "Clip gara",
								})}
								{getListItem({
									path: "/video?type=Video tecnici",
									label: "Video tecnici",
								})}
							</List>
						</Collapse>
					</List>
				);
				break;
			case "analyst":
				list = (
					<List className="side-menu-list">
						{getListItem({
							path: "/match-calendar",
							imagePath: require("@/assets/images/manager/calendar.png"),
							label: t("calendar"),
						})}
						{getListItem({
							path: "/matches",
							imagePath: require("@/assets/images/coach/match.png"),
							label: t("matches"),
						})}
						{getListItem({
							path: "/match-reports",
							imagePath: require("@/assets/images/manager/evaluation.png"),
							label: t("match_report"),
						})}
						<ListItem
							button
							onClick={() => handleClick(setVideoOpen, videoOpen)}
						>
							<ListItemIcon>
								<ListItemIcon>
									<img
										className="item-icon"
										src={require("@/assets/images/manager/video.png")}
										alt=""
									/>
								</ListItemIcon>
							</ListItemIcon>
							<ListItemText primary={t("video")} />
							{videoOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse
							in={videoOpen}
							timeout="auto"
							unmountOnExit
							className="collapsed"
						>
							<List component="div" disablePadding>
								{getListItem({
									path: "/video?type=Clip allenamento",
									label: "Clip allenamento",
								})}
								{getListItem({
									path: "/video?type=Clip gara",
									label: "Clip gara",
								})}
								{getListItem({
									path: "/video?type=Video tecnici",
									label: "Video tecnici",
								})}
							</List>
						</Collapse>
					</List>
				);
				break;
			case "scout":
				list = <List className="side-menu-list">{scoutingList}</List>;
				break;
			case "settings":
				list = (
					<List className="side-menu-list">
						{getListItem({
							path: "/settings/staff-units",
							imagePath: require("@/assets/images/manager/staff.png"),
							label: t("staff_areas"),
						})}
						{getListItem({
							path: "/settings/categories",
							imagePath: require("@/assets/images/manager/category.png"),
							label: t("categories"),
						})}
						{getListItem({
							path: "/settings/clubs",
							imagePath: require("@/assets/images/manager/club.png"),
							label: t("club"),
						})}
						{getListItem({
							path: "/manager/teams",
							imagePath: require("@/assets/images/manager/club.png"),
							label: t("rosters"),
						})}
						{getListItem({
							path: "/settings/staff-roles",
							imagePath: require("@/assets/images/manager/staff.png"),
							label: t("staff_roles"),
						})}
						{getListItem({
							path: "/settings/user-roles",
							imagePath: require("@/assets/images/manager/staff.png"),
							label: t("user_roles"),
						})}
						{getListItem({
							path: "/settings/teams",
							imagePath: require("@/assets/images/manager/club.png"),
							label: t("teams"),
						})}
						{getListItem({
							path: "/settings/users",
							imagePath: require("@/assets/images/user.png"),
							label: t("users"),
						})}
					</List>
				);
				break;
			default:
				break;
		}

		const shouldShowSeasonCard =
			selectedMenuItem === "manager" || selectedMenuItem === "coach";

		const wrappedList = list ? (
			<div
				className={`side-container ${!shouldShowSeasonCard ? "no-season-card" : ""}`}
			>
				<div className="side-menu-scroll">
					{shouldShowSeasonCard && seasonsSelect}
					{list}
				</div>
			</div>
		) : null;

		if (mobile) {
			return (
				<div className="d-flex flex-column">
					<VLFSelectNew
						containerStyles={{
							display: "flex",
							justifyContent: "center",
						}}
						controlStyles={{
							margin: "10px 5px",
							width: "220px",
						}}
						options={visibleHeaderMenuItems}
						isClearable={false}
						sorted={false}
						value={visibleHeaderMenuItems.filter(
							(hm) => hm.value === selectedMenuItem,
						)}
						onChange={(item) => {
							dispatch(setSelectedMenuItem(item.value));
						}}
					/>
					{wrappedList}
					{getUserInfo()}
				</div>
			);
		}

		return wrappedList;
	};

	return (
		<>
			<div className="side-menu-container">
				<div className="hide-mobile">{getUserInfo()}</div>
				<div
					className="sandwich"
					onClick={() => setOpenMobileMenu(!openMobileMenu)}
				>
					<MenuIcon />
				</div>
				<Drawer
					variant="temporary"
					anchor="left"
					open={openMobileMenu}
					onClose={() => setOpenMobileMenu(!openMobileMenu)}
				>
					{getList(true)}
				</Drawer>
				{getList()}
			</div>
			{openHandleLogout && (
				<VLFModal
					open={openHandleLogout}
					title="Logout"
					content={
						<div className="mt-2">
							Sei sicuro di voler effettuare il logout?
						</div>
					}
					confirm={() => {
						localStorage.setItem("token", "");
						setOpenHandleLogout(false);
						dispatch(logout());
					}}
					close={() => setOpenHandleLogout(false)}
					confirmLabel="Conferma"
				/>
			)}
		</>
	);
}

export default SideMenu;
